export default [
  {
    path: '/board-250CL',
    alias: ['/board-250CL-X'],
    component: () => import('@/views/board/250CL-X/Index.vue'),
    name: 'board-250CL-X',
    meta: {
      title: '250CL-X实时销售表',
      backgroundClass: 'bg-primary',
    },
  },
];
